export default "__VITE_ASSET__CWnU5pyl__"